module.exports = __webpack_public_path__ + "img/box_no_data.cb7cf307.svg";